var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 7.58329C7.32213 7.58329 7.58329 7.32213 7.58329 6.99996C7.58329 6.67779 7.32213 6.41663 6.99996 6.41663C6.67779 6.41663 6.41663 6.67779 6.41663 6.99996C6.41663 7.32213 6.67779 7.58329 6.99996 7.58329Z",
    fill: "#949494",
    stroke: "#949494",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91671 7.58329C3.23887 7.58329 3.50004 7.32213 3.50004 6.99996C3.50004 6.67779 3.23887 6.41663 2.91671 6.41663C2.59454 6.41663 2.33337 6.67779 2.33337 6.99996C2.33337 7.32213 2.59454 7.58329 2.91671 7.58329Z",
    fill: "#949494",
    stroke: "#949494",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 7.58329C11.4055 7.58329 11.6667 7.32213 11.6667 6.99996C11.6667 6.67779 11.4055 6.41663 11.0833 6.41663C10.7612 6.41663 10.5 6.67779 10.5 6.99996C10.5 7.32213 10.7612 7.58329 11.0833 7.58329Z",
    fill: "#949494",
    stroke: "#949494",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/MoreOptions.f76edb9e4a6ed027cad463e39c9dbae8.svg";
export { ForwardRef as ReactComponent };